var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#4B5162;}\n\t.st2{display:inline;}\n\t.st3{fill:#4B5162;}\n\t.st4{fill:#466DEC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,28.9c-1.3-1.3-2.8-2.2-4.5-2.7c1.7-1.3,2.8-3.4,2.8-5.7c0-4-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3 c0,2.3,1.1,4.4,2.8,5.8C6,27.5,2.7,31.6,2.7,36.4c0,0.6,0.4,1,1,1s1-0.4,1-1c0-4.8,3.9-8.6,8.6-8.6h1.5l0,0l0,0h1.5 c4.8,0,8.6,3.9,8.6,8.6c0,0.6,0.4,1,1,1s1-0.4,1-1C27,33.5,25.9,30.9,23.9,28.9z M9.6,20.4c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3 s-2.4,5.3-5.3,5.3l0,0C11.9,25.7,9.6,23.4,9.6,20.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10.92, 511.47)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_34-2_2_",
    transform: "translate(14.3 8.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4-515.2l3.3,5.7l-3.3,5.7h-6.6l-3.3-5.7l3.3-5.7H6.4 M7.6-517.2h-8.9l-4.5,7.7l4.5,7.7h8.9l4.5-7.7 L7.6-517.2L7.6-517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4-515.2l3.3,5.7l-3.3,5.7h-6.6l-3.3-5.7l3.3-5.7H6.4 M7.6-517.2h-8.9l-4.5,7.7l4.5,7.7h8.9l4.5-7.7 L7.6-517.2L7.6-517.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    transform: "translate(-1294.392 -1011.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1325.1,1044.1h-21.4c-2.5,0-4.6-2.1-4.6-4.6v-16.1c0-2.1,1.7-3.8,3.8-3.8h25.3c0.6,0,1.1,0.4,1.5,0.9 c0.2,0.6,0.1,1.2-0.4,1.7l-0.9,0.9c-0.6,0.6-1.6,0.6-2.1,0c-0.2-0.2-0.2-0.3-0.3-0.5H1303c-0.5,0-0.8,0.3-0.8,0.8v16.1 c0,0.8,0.7,1.5,1.5,1.5h21.4c0.8,0,1.5-0.7,1.5-1.5v-11.4c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v11.3 C1329.7,1042.1,1327.7,1044.1,1325.1,1044.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1314.4,1034.1c-0.3,0-0.7-0.2-1-0.4l-12.8-10.4c-0.7-0.5-0.8-1.5-0.2-2.1c0.5-0.7,1.5-0.8,2.1-0.2l11.8,9.6 l11.9-9.6c0.7-0.5,1.6-0.5,2.1,0.2c0.5,0.7,0.5,1.6-0.2,2.1l-12.9,10.4C1315.1,1034,1314.7,1034.1,1314.4,1034.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.ce5fbc4eac2e0a79ba6f24d5f65a7be4.svg";
export { ForwardRef as ReactComponent };